import React, {useEffect} from 'react';
import ProgramList from "./_list";

import {showLoader} from "../../../components/loader/loader";
import {ADD_STATE, REMOVE_STATE, setApp, setUdn} from "../../../redux/actions/generics/IndexedActions";
import {useSelector} from 'react-redux';
import {getStateByPath} from "../../../redux/selectors";
import {connect} from "react-redux";

const Program = (props) => {
    const path = props.path || 'atv/program';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { viewMode, loading } = componentState?.data || {};

    useEffect(() => {
        props.ADD_STATE(path);

        if (props.app !== null)
            props.setApp(path, props.app);

        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn !== null)
            props.setUdn(path, _udn);

        return () => {
            props.REMOVE_STATE(path);
        }
    },[]);

    return (
        <>
            {loading && showLoader()}
            { componentState && <ProgramList path={path} /> }
        </>
    );
}

const mapStateToProps = state => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setUdn
});

export default connect(mapStateToProps, mapActionsToProps)(Program)
